const Monitoring = ({ size = 24, color = "var(--primary-text-color)", tooltip = { content: '', position: '' } }) => {

    const tooltipProps = tooltip.content
        ? {
            'data-tooltip-content': tooltip.content,
            'data-tooltip-position': tooltip.position,
        }
        : {};

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={`${size}px`}
            width={`${size}px`}
            viewBox="0 -960 960 960"
            fill={color}
            {...tooltipProps}

        >
            <path d="M120-120v-80l80-80v160zm160 0v-240l80-80v320zm160 0v-320l80 81v239zm160 0v-239l80-80v319zm160 0v-400l80-80v480zM120-327v-113l280-280 160 160 280-280v113L560-447 400-607z" />
        </svg>
    )
}

export default Monitoring;